import type { QuizStep } from "../../types"

interface Props {
  step: QuizStep
}

/**
 * Display-only step. The renderer chrome already shows the title/subtitle, so
 * this only adds an optional illustration (e.g. an interstitial before a
 * processing step).
 */
export function InfoStep({ step }: Props) {
  if (!step.coverImage) return null
  return (
    <div className="flex flex-1 items-center justify-center py-4">
      <img src={step.coverImage} alt="" className="w-full max-w-[300px] object-contain" />
    </div>
  )
}
